import UploadClient from './upload-client';

export async function generateStaticParams() {
  return [{ id: 'placeholder' }];
}

export default function UploadPage({ params }: { params: { id: string } }) {
  return <UploadClient eventId={params.id} />;
}
